
export default function RequirementsSection() {
  const requirements = [
    { icon: 'ri-user-line', label: '年齢', value: '18歳以上75歳未満', note: '※2022年4月より18歳に引き下げ' },
    { icon: 'ri-map-pin-line', label: '居住地', value: '日本国内に居住', note: '海外在住の方は不可' },
    { icon: 'ri-mail-line', label: '連絡先', value: 'メールアドレス必須', note: 'フリーメール可' },
    { icon: 'ri-id-card-line', label: '本人確認', value: '本人確認書類＋マイナンバー', note: '上記の書類を参照' },
  ];

  const ngCases = [
    '日本国外に居住している方',
    '75歳以上の方',
    '金融商品取引業者の従業員',
    '反社会的勢力に該当する方',
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">口座開設の条件</h2>
          <p className="text-gray-600">以下の条件を満たしていれば、どなたでも申し込み可能です</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-10">
          {requirements.map((req, i) => (
            <div key={i} className="bg-white rounded-xl p-5 border border-gray-100 flex items-start gap-4 hover:shadow-md transition-shadow">
              <div className="w-11 h-11 flex items-center justify-center bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl flex-shrink-0">
                <i className={`${req.icon} text-teal-600 text-lg`}></i>
              </div>
              <div>
                <p className="text-xs text-gray-500 mb-0.5">{req.label}</p>
                <p className="text-sm font-bold text-gray-900 mb-1">{req.value}</p>
                <p className="text-xs text-gray-500">{req.note}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-red-50 border border-red-200 rounded-xl p-6">
          <h3 className="font-bold text-gray-900 mb-4 flex items-center gap-2 text-sm">
            <i className="ri-close-circle-line text-red-500 text-lg"></i>
            口座開設できないケース
          </h3>
          <div className="grid md:grid-cols-2 gap-3">
            {ngCases.map((item, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-gray-700">
                <i className="ri-close-line text-red-400"></i>
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
